/**
 * RevWorks — Detailing Services page: Enquiries form.
 *
 * One small progressive enhancement the existing Studio/Protection
 * Services enquiry form (sections/rw-page-studio-enquiries.liquid)
 * doesn't have: disabling the submit button the moment the native
 * form submit event fires, so a second click before the page
 * navigates away with the response can't send a duplicate enquiry.
 * Native browser validation (the fields' own `required` attributes)
 * still runs first and can block the event entirely, so an incomplete
 * form is never disabled. This never intercepts or replaces the
 * actual submission — the form still posts natively to Shopify's
 * contact handler exactly as before.
 */
(function () {
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  init(document);

  function init(scope) {
    var forms = scope.querySelectorAll('[data-rw-detailing-enquiries-form]');
    forms.forEach(function (form) {
      if (form.hasAttribute('data-rw-detailing-enquiries-form-inited')) return;
      form.setAttribute('data-rw-detailing-enquiries-form-inited', '');

      form.addEventListener('submit', function () {
        var submitButton = form.querySelector('[data-rw-detailing-enquiries-submit]');
        if (!submitButton || submitButton.disabled) return;
        submitButton.disabled = true;
      });
    });
  }
})();
